import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  captureAndStoreQueryParamsFromSearch,
  mergeSearchWithStored,
  normalizeSearch,
} from '../Utils/utm';

/**
 * Keeps UTM params + clickid persisted across the website:
 * - Stores them in localStorage when they appear in URL (supports clickid and click_id)
 * - Ensures they remain in the URL across internal navigation
 */
export default function UtmPersist() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // 1) Capture any tracked params from current URL (including click_id -> clickid)
    captureAndStoreQueryParamsFromSearch(location.search);

    // 2) Ensure current URL has stored params (merge in if missing)
    const desiredSearch = mergeSearchWithStored(location.search);
    if (normalizeSearch(desiredSearch) !== normalizeSearch(location.search)) {
      navigate(
        {
          pathname: location.pathname,
          search: desiredSearch,
          hash: location.hash,
        },
        { replace: true, state: location.state }
      );
    }
  }, [location.pathname, location.search, location.hash, navigate]);

  return null;
}
